module.exports = {"361126001":"桃源街道","361126002":"花亭街道","361126101":"曹溪镇","361126102":"漆工镇","361126103":"樟树墩镇","361126104":"南岩镇","361126105":"朱坑镇","361126106":"圭峰镇","361126107":"叠山镇","361126108":"港口镇","361126109":"弋江镇","361126110":"三县岭镇","361126202":"中畈乡","361126203":"葛溪乡","361126204":"湾里乡","361126206":"清湖乡","361126207":"旭光乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361126.json
// module id = 1345
// module chunks = 0